<template>
  <div class="hide-500">
    <menu class="menu">
      <button
        class="menu__item"
        :class="$route.name == 'Home' ? 'active' : ''"
        id="Home"
        style="--bgColorItem: #ff8c00;"
        @click="openUi('/')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 256 256"
          id="house"
          width="24"
          height="24"
        >
          <path
            fill="white"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="12"
            d="M151.99414,207.99263v-48.001a8,8,0,0,0-8-8h-32a8,8,0,0,0-8,8v48.001a8,8,0,0,1-7.999,8l-47.99414.00632a8,8,0,0,1-8.001-8v-92.4604a8,8,0,0,1,2.61811-5.91906l79.9945-72.73477a8,8,0,0,1,10.76339-.00036l80.0055,72.73509A8,8,0,0,1,216,115.53887V207.999a8,8,0,0,1-8.001,8l-48.00586-.00632A8,8,0,0,1,151.99414,207.99263Z"
          ></path>
        </svg>
      </button>
      <button
        class="menu__item"
        :class="$route.name == 'Schemes' ? 'active' : ''"
        id="Schemes"
        style="--bgColorItem: #f54888;"
        @click="openUi('schemes')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            stroke="white"
            fill="white"
            d="M21 9V6H7v3h14m0-6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14M3 19h15v2H3a2 2 0 0 1-2-2V8h2Z"
          />
        </svg>
      </button>
      <button
        class="menu__item"
        :class="$route.name == 'History' ? 'active' : ''"
        id="History"
        style="--bgColorItem: #4343f5;"
        @click="openUi('history')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            fill="white"
            stroke="white"
            d="M13.5 8H12v5l4.28 2.54l.72-1.21l-3.5-2.08V8M13 3a9 9 0 0 0-9 9H1l3.96 4.03L9 12H6a7 7 0 0 1 7-7a7 7 0 0 1 7 7a7 7 0 0 1-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.896 8.896 0 0 0 13 21a9 9 0 0 0 9-9a9 9 0 0 0-9-9"
          />
        </svg>
      </button>
      <button
        class="menu__item"
        :class="$route.name == 'MemberList' ? 'active' : ''"
        id="MemberList"
        style="--bgColorItem: #4343f5;"
        @click="openUi('memberList')"
      >
        <!-- @click="$emit('openBtm')" -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            stroke="white"
            fill="white"
            d="M15 14c-2.67 0-8 1.33-8 4v2h16v-2c0-2.67-5.33-4-8-4m0-2a4 4 0 0 0 4-4a4 4 0 0 0-4-4a4 4 0 0 0-4 4a4 4 0 0 0 4 4M5 13.28l2.45 1.49l-.65-2.81L9 10.08l-2.89-.25L5 7.19L3.87 9.83L1 10.08l2.18 1.88l-.68 2.81L5 13.28Z"
          />
        </svg>
      </button>

      <button
        class="menu__item"
        :class="$route.name == 'Member' ? 'active' : ''"
        id="Member"
        style="--bgColorItem: #4343f5;"
        @click="openUi('member')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            stroke="white"
            fill="white"
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88a9.947 9.947 0 0 1 12.28 0C16.43 19.18 14.03 20 12 20z"
          />
        </svg>
      </button>

      <div class="menu__border"></div>
    </menu>

    <div class="svg-container">
      <svg viewBox="0 0 202.9 45.5">
        <clipPath
          id="menu"
          clipPathUnits="objectBoundingBox"
          transform="scale(0.0049285362247413 0.021978021978022)"
        >
          <path
            d="M6.7,45.5c5.7,0.1,14.1-0.4,23.3-4c5.7-2.3,9.9-5,18.1-10.5c10.7-7.1,11.8-9.2,20.6-14.3c5-2.9,9.2-5.2,15.2-7
          c7.1-2.1,13.3-2.3,17.6-2.1c4.2-0.2,10.5,0.1,17.6,2.1c6.1,1.8,10.2,4.1,15.2,7c8.8,5,9.9,7.1,20.6,14.3c8.3,5.5,12.4,8.2,18.1,10.5
          c9.2,3.6,17.6,4.2,23.3,4H6.7z"
          />
        </clipPath>
      </svg>
    </div>
  </div>
</template>
<script>
import Route from "vue-router";
export default {
  data: () => ({
    body: "",
    bgColorsBody: ["#ffb457", "#ff96bd", "#9999fb", "#ffe797", "#cffff1"],
    menu: "",
    menuItems: "",
    menuBorder: "",
    activeItem: "",
  }),
  mounted() {
    this.setupBtmNav();
  },
  watch:{
    '$route'(nv){
      // console.log("nv",nv);
      this.activeItem = document.getElementById(nv.name);
      this.offsetMenuBorder(this.activeItem,this.menuBorder);
    }
  },
  methods: {
    setupBtmNav() {
      this.body = document.body;
      this.menu = this.body.querySelector(".menu");
      this.menuItems = this.menu.querySelectorAll(".menu__item");
      this.menuBorder = this.menu.querySelector(".menu__border");
      this.activeItem = this.menu.querySelector(".active");
      window.addEventListener("resize", () => {
        this.offsetMenuBorder(this.activeItem, this.menuBorder);
        this.menu.style.setProperty("--timeOut", "none");
      });
      this.menuItems.forEach((item, index) => {
        item.addEventListener("click", () => this.clickItem(item, index));
      });
      if(this.activeItem){
        this.offsetMenuBorder(this.activeItem, this.menuBorder);
      }else{
        setTimeout(()=>{this.setupBtmNav();},100)
      };
    },
    clickItem(item, index) {
      this.menu.style.removeProperty("--timeOut");

      if (this.activeItem == item) return;

      if (this.activeItem) {
        this.activeItem.classList.remove("active");
      }

      item.classList.add("active");
      // this.body.style.backgroundColor = this.bgColorsBody[index];
      this.activeItem = item;
      this.offsetMenuBorder(this.activeItem, this.menuBorder);
    },
    offsetMenuBorder(element, menuBorder) {
      const offsetActiveItem = element.getBoundingClientRect();
      const left =
        Math.floor(
          offsetActiveItem.left -
            this.menu.offsetLeft -
            (menuBorder.offsetWidth - offsetActiveItem.width) / 2
        ) + "px";
      menuBorder.style.transform = `translate3d(${left}, 0 , 0)`;
    },
    openUi(route) {
      this.$router.push(route);
    },
  },
};
</script>
<style>
html {
  /* box-sizing: border-box; */
  /* --bgColorMenu: #244493; */
  --duration: 0.7s;
}
/* html *,
html *::before,
html *::after {
  box-sizing: inherit;
} */
/* body {
  margin: 0;
  display: flex;
  height: 100vh;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  background-color: #ffb457;
  -webkit-tap-highlight-color: transparent;
  transition: background-color var(--duration);
} */
.menu {
  margin: 0;
  display: flex;
  /* Works well with 100% width  */
  /* width: 32.05em; */
  font-size: 1.5em;
  padding: 0 2.85em;
  position: relative;
  align-items: center;
  justify-content: center;
  background-color: #351036;
  /* width: 100%; */
}
.menu__item {
  all: unset;
  flex-grow: 1;
  z-index: 100;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer;
  position: relative;
  border-radius: 50%;  
  will-change: transform;  
  padding: 1.6em 0 0.85em;
  transition: transform var(--timeOut, var(--duration));
}

.menu__item::before {
  content: "";
  z-index: -1;
  width: 4.2em;
  height: 4.2em;
  border-radius: 50%;
  position: absolute;
  transform: scale(0);
  transition: background-color var(--duration), transform var(--duration);
}
.menu__item.active {
  transform: translate3d(0, -0.8em, 0);
}
.menu__item.active::before {
  transform: scale(1);
  /* background-color: var(--bgColorItem); */
  background-color: white;
}
.icon {
  width: 2.6em;
  height: 2.6em;
  stroke: #351036;
  fill: transparent;
  stroke-width: 1pt;
  stroke-miterlimit: 10;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 400;
}
.menu__item.active .icon {
  animation: strok 1.5s reverse;
}
.menu__item.active path {
  fill: #351036;
  stroke: #351036;
}
@keyframes strok {
  100% {
    stroke-dashoffset: 400;
  }
}
.menu__border {
  left: 0;
  bottom: 99%;
  width: 10.9em;
  height: 2.4em;
  position: absolute;
  clip-path: url(#menu);
  will-change: transform;
  background-color: #351036;
  transition: transform var(--timeOut, var(--duration));
}

.svg-container {
  width: 0;
  height: 0;
}

@media screen and (max-width: 50em) {
  .menu {
    font-size: 0.8em;
  }
}
</style>
